// extracted by mini-css-extract-plugin
var _1 = "text-divider-vertical___dsZRA";
export { _1 as "text-divider-vertical" }
